module.exports = __webpack_public_path__ + "static/media/france_flag.f689ce44.svg";